function Micronesia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1651)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
  <path d="M16 6.95703L16.6907 9.08278H18.9259L17.1177 10.3966L17.8083 12.5223L16 11.2085L14.1917 12.5223L14.8825 10.3966L13.0742 9.08278H15.3094L16 6.95703Z" fill="#F0F0F0"/>
  <path d="M6.95654 16.0002L9.08229 15.3095V13.0742L10.3961 14.8826L12.5218 14.1919L11.208 16.0002L12.5218 17.8083L10.3961 17.1176L9.08229 18.9259V16.6908L6.95654 16.0002Z" fill="#F0F0F0"/>
  <path d="M16.0002 25.0438L15.3095 22.918H13.0742L14.8826 21.6042L14.1919 19.4785L16.0002 20.7923L17.8083 19.4785L17.1176 21.6042L18.9259 22.918H16.6908L16.0002 25.0438Z" fill="#F0F0F0"/>
  <path d="M25.0435 16L22.9178 16.6907V18.9259L21.604 17.1176L19.4783 17.8083L20.792 16L19.4783 14.1918L21.604 14.8826L22.9178 13.0742V15.3094L25.0435 16Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Micronesia;
